//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import SingleDatePicker from 'common/components/core/date_picker/DatePicker';
import moment from 'moment-timezone';
import TimeUtils from 'common/utils/TimeUtils';

type Props = {
    theme: Object,
    date: string,
    highlightStartDate?: string,
    highlightEndDate?: string,
    isDayHighlighted?: (day: moment) => boolean,
    onChange?: moment => void,
    isMultiDay: boolean,
    minDate: string,
    maxDate?: string
};
class SingleDayPicker extends React.PureComponent<Props, State> {
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            focused: true
        };
    }
    onDateChange = (date, e) => {
        this.props.onChange && this.props.onChange(date, e);
    };
    onFocusChange = () => {
        this.setState({ focused: true });
    };
    initialVisibleMonth = () => {
        return this.props.date;
    };

    isStartSelected = () => {
        const { highlightStartDate, date } = this.props;
        return TimeUtils.isSame(date, highlightStartDate);
    };

    isEndSelected = () => {
        const { highlightEndDate, date } = this.props;
        return TimeUtils.isSame(date, highlightEndDate);
    };

    isDayHighlighted = day => {
        const {
            highlightStartDate,
            highlightEndDate,
            isDayHighlighted
        } = this.props;
        if (isDayHighlighted) {
            return isDayHighlighted(day);
        }
        if (highlightStartDate && highlightEndDate && day) {
            return moment(day).isBetween(
                highlightStartDate,
                highlightEndDate,
                'days',
                '[]'
            );
        }
        return false;
    };

    isDayBlocked = date => {
        const { minDate, maxDate } = this.props;
        const isCurrentDateBeforeMin = minDate
            ? date.isBefore(moment(minDate))
            : false;
        const isCurrentDateAfterMax = maxDate
            ? date.isAfter(moment(maxDate))
            : false;
        return isCurrentDateBeforeMin || isCurrentDateAfterMax;
    };

    render() {
        const { theme, date, isMultiDay } = this.props;
        return (
            <SingleDatePicker
                theme={theme}
                date={date}
                isDayBlocked={this.isDayBlocked}
                isStartSelected={this.isStartSelected()}
                isEndSelected={this.isEndSelected()}
                isMultiDay={isMultiDay}
                isDayHighlighted={this.isDayHighlighted}
                initialVisibleMonth={this.initialVisibleMonth}
                onDateChange={this.onDateChange}
                focused={this.state.focused}
                onFocusChange={this.onFocusChange}
            />
        );
    }
}

const ThemedSingleDayPicker = themr('SingleDayPicker')(SingleDayPicker);

export { ThemedSingleDayPicker as SingleDayPicker };
export default ThemedSingleDayPicker;
